// import React from "react";
// import { useState } from "react";
// import "./header.css";

// const Header = () => {
//   /*=============== Change Background Header ===============*/
//   window.addEventListener("scroll", function () {
//     const header = document.querySelector(".header");
//     // when the scroll is higher then 200 viewport height, add
//     //the scroll-geader class to tag with the header tag
//     if (this.scrollY >= 80) header.classList.add("scroll-header");
//     else header.classList.remove("scroll-header");
//   });
//   /*=============== Toggle Menu ===============*/
//   const [Toggle, showMenu] = useState(false);
//   const [activeNav, setActiveNav] = useState("#home");

//   return (
//     <header className="header">
//       <nav className="nav container">
//         <a href="index.html" className="nav__logo">
//           Amit
//         </a>

//         <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
//           <ul className="nav__list grid">
//             <li className="nav__item">
//               <a
//                 href="#home"
//                 onClick={() => setActiveNav("#home")}
//                 className={
//                   activeNav === "#home" ? "nav__link active-link" : "nav__link"
//                 }
//               >
//                 <i className="uil uil-estate nav__icon"></i> Home
//               </a>
//             </li>

//             <li className="nav__item">
//               <a
//                 href="#about"
//                 onClick={() => setActiveNav("#about")}
//                 className={
//                   activeNav === "#about" ? "nav__link active-link" : "nav__link"
//                 }
//               >
//                 <i className="uil uil-user nav__icon"></i> About
//               </a>
//             </li>

//             <li className="nav__item">
//               <a
//                 href="#skills"
//                 onClick={() => setActiveNav("#skills")}
//                 className={
//                   activeNav === "#skills"
//                     ? "nav__link active-link"
//                     : "nav__link"
//                 }
//               >
//                 <i className="uil uil-file-alt nav__icon"></i> Skills
//               </a>
//             </li>

//             {/* <li className="nav__item">
//               <a
//                 href="#services"
//                 onClick={() => setActiveNav("#services")}
//                 className={
//                   activeNav === "#services"
//                     ? "nav__link active-link"
//                     : "nav__link"
//                 }
//               >
//                 <i className="uil uil-briefcase-alt nav__icon"></i> Services
//               </a>
//             </li>

//             <li className="nav__item">
//               <a
//                 href="#portfolio"
//                 onClick={() => setActiveNav("#portfolio")}
//                 className={
//                   activeNav === "#portfolio"
//                     ? "nav__link active-link"
//                     : "nav__link"
//                 }
//               >
//                 <i className="uil uil-scenery nav__icon"></i> Portfolio
//               </a>
//             </li> */}

//             <li className="nav__item">
//               <a
//                 href="#contact"
//                 onClick={() => setActiveNav("#contact")}
//                 className={
//                   activeNav === "#contact"
//                     ? "nav__link active-link"
//                     : "nav__link"
//                 }
//               >
//                 <i className="uil uil-message nav__icon"></i> Contact
//               </a>
//             </li>
//           </ul>

//           <i
//             class="uil uil-times nav__close"
//             onClick={() => showMenu(!Toggle)}
//           ></i>
//         </div>

//         <div className="nav__toggle" onClick={() => showMenu(!Toggle)}>
//           <i class="uil uil-apps"></i>
//         </div>
//       </nav>
//     </header>
//   );
// };

// export default Header;

// -----------
import React, { useState, useEffect, useRef } from "react";
import "./header.css";

const Header = () => {
  const [toggle, setToggle] = useState(false);
  const [activeNav, setActiveNav] = useState("#home");

  // Load the initial theme from localStorage
  const savedTheme = localStorage.getItem("dark-theme") === "true";
  const [darkTheme, setDarkTheme] = useState(savedTheme);

  const headerRef = useRef(null);

  // Apply dark theme class to <html> on change
  useEffect(() => {
    const root = document.documentElement;
    if (darkTheme) {
      root.classList.add("dark-theme");
    } else {
      root.classList.remove("dark-theme");
    }
    localStorage.setItem("dark-theme", darkTheme.toString());
  }, [darkTheme]);

  // Scroll effect for header background
  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        if (window.scrollY >= 80) {
          headerRef.current.classList.add("scroll-header");
        } else {
          headerRef.current.classList.remove("scroll-header");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Prevent body scroll when menu is open (mobile)
  useEffect(() => {
    document.body.style.overflow = toggle ? "hidden" : "auto";
  }, [toggle]);

  return (
    <header className="header" ref={headerRef}>
      <nav
        className="nav container"
        role="navigation"
        aria-label="Main Navigation"
      >
        <a href="#home" className="nav__logo">
          Amit
        </a>

        <div className={toggle ? "nav__menu show-menu" : "nav__menu"}>
          <ul className="nav__list grid">
            <li className="nav__item">
              <a
                href="#home"
                onClick={() => setActiveNav("#home")}
                className={
                  activeNav === "#home" ? "nav__link active-link" : "nav__link"
                }
              >
                <i className="uil uil-estate nav__icon"></i> Home
              </a>
            </li>

            <li className="nav__item">
              <a
                href="#about"
                onClick={() => setActiveNav("#about")}
                className={
                  activeNav === "#about" ? "nav__link active-link" : "nav__link"
                }
              >
                <i className="uil uil-user nav__icon"></i> About
              </a>
            </li>

            <li className="nav__item">
              <a
                href="#skills"
                onClick={() => setActiveNav("#skills")}
                className={
                  activeNav === "#skills"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-file-alt nav__icon"></i> Skills
              </a>
            </li>

            <li className="nav__item">
              <a
                href="#contact"
                onClick={() => setActiveNav("#contact")}
                className={
                  activeNav === "#contact"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-message nav__icon"></i> Contact
              </a>
            </li>
          </ul>

          <i
            className="uil uil-times nav__close"
            onClick={() => setToggle(false)}
            aria-label="Close menu"
          ></i>
        </div>

        <div className="nav__btns">
          {/* Mobile Menu Toggle */}
          <div
            className="nav__toggle"
            onClick={() => setToggle(true)}
            aria-label="Open menu"
            aria-expanded={toggle ? "true" : "false"}
            aria-controls="nav-menu"
          >
            <i className="uil uil-apps"></i>
          </div>

          {/* Theme Toggle Icon */}
          <i
            className={
              darkTheme
                ? "uil uil-sun change-theme"
                : "uil uil-moon change-theme"
            }
            onClick={() => setDarkTheme(!darkTheme)}
            title={darkTheme ? "Light Mode" : "Dark Mode"}
          ></i>
        </div>
      </nav>
    </header>
  );
};

export default Header;
